import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { isPathActive } from 'utils/is-path-active';

export function AppFooter() {
  const { t } = useTranslation();
  const location = useLocation();
  const isChatPage =
    isPathActive(location.pathname, '/chat') || isPathActive(location.pathname, '/agentChat');

  return (
    <footer
      data-testid="app-footer"
      className={`mt-auto w-full shrink-0 bg-white dark:bg-background${isChatPage ? ' hidden md:block' : ''}`}
    >
      <div className="flex flex-col items-center justify-center px-6 py-2">
        <div className="flex items-center gap-2">
          {isChatPage && (
            <p className="hidden text-center text-[10px] text-neutral-400 md:block">
              {t('FOOTER_DISCLAIMER')}
            </p>
          )}
          {/* <HelpCircle className="size-5 text-neutral-400" /> */}
        </div>
      </div>
    </footer>
  );
}
